import React from 'react';
import { NextPage } from 'next';
import get from 'lodash/get';
import { CacheControlHeaders } from 'constants/Global';
import { reduxWrapper } from 'store';
import QuizView from 'views/QuizView';
import ApiClient from 'lib/SanityClient/ApiClient';

import type { Quiz as IQuiz } from 'types';

interface Props {
  quiz: IQuiz | null;
}

const QuizPage: NextPage<Props> = ({ quiz }: Props) => {
  return <QuizView quiz={quiz} />;
};

export const getServerSideProps = reduxWrapper.getServerSideProps(
  async ({ params, res }) => {
    res.setHeader('Cache-Control', CacheControlHeaders.NO_CACHE);

    const primarySlug = get(params, 'slug', '') as string;

    try {
      const slug = `/${primarySlug}`;
      const quiz = await ApiClient.fetchQuiz(slug);

      if (!quiz) {
        throw new Error('No Quiz found');
      }

      return {
        props: {
          quiz,
        },
      };
    } catch (err) {
      return {
        notFound: true,
      };
    }
  },
);

export default reduxWrapper.withRedux(QuizPage);
